export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_14.d6486aa4.jpg";